// Actions for the data-lineage list page only.
// Canvas persistence (load/save/publish) lives in store/lineageActions.js.
import axios from 'axios';
import Auth from '../../auth/auth';

export const FETCH_LINEAGES_REQUEST = 'FETCH_LINEAGES_REQUEST';
export const FETCH_LINEAGES_SUCCESS = 'FETCH_LINEAGES_SUCCESS';
export const FETCH_LINEAGES_FAILURE = 'FETCH_LINEAGES_FAILURE';

const auth = new Auth();
const {getAccessToken} = auth;

const headers = () => ({
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'x-access-token': getAccessToken(),
});

export const fetchLineages = () => (dispatch) => {
  dispatch({type: FETCH_LINEAGES_REQUEST});
  return axios.get(`${process.env.REACT_APP_API_URL}/lineage/diagrams`, {headers: headers()})
      .then((response) => response.data)
      .then((json) => {
        dispatch({type: FETCH_LINEAGES_SUCCESS, payload: json});
      })
      .catch((error) => {
        dispatch({type: FETCH_LINEAGES_FAILURE, payload: error.message || error, error: true});
      });
};

export const DELETE_LINEAGE_REQUEST = 'DELETE_LINEAGE_REQUEST';
export const DELETE_LINEAGE_SUCCESS = 'DELETE_LINEAGE_SUCCESS';
export const DELETE_LINEAGE_FAILURE = 'DELETE_LINEAGE_FAILURE';

export const deleteLineage = (id) => (dispatch) => {
  dispatch({type: DELETE_LINEAGE_REQUEST});
  return axios.delete(`${process.env.REACT_APP_API_URL}/lineage/diagram/${id}`, {headers: headers()})
      .then((response) => response.data)
      .then((json) => {
        dispatch({type: DELETE_LINEAGE_SUCCESS, payload: id});
        dispatch(fetchLineages());
        return json;
      })
      .catch((error) => {
        dispatch({type: DELETE_LINEAGE_FAILURE, payload: error.message || error, error: true});
      });
};

// DD picker calls used by the list page (instances/objects/view-lineage discovery)
export const LOAD_INSTANCES_REQUEST = 'LOAD_INSTANCES_REQUEST';
export const LOAD_INSTANCES_SUCCESS = 'LOAD_INSTANCES_SUCCESS';
export const LOAD_INSTANCES_FAILURE = 'LOAD_INSTANCES_FAILURE';

export const loadInstances = () => (dispatch) => {
  dispatch({type: LOAD_INSTANCES_REQUEST});
  return axios.get(`${process.env.REACT_APP_API_URL}/dataDictionary/instances`, {headers: headers()})
      .then((response) => response.data)
      .then((json) => dispatch({type: LOAD_INSTANCES_SUCCESS, payload: json}))
      .catch((error) => dispatch({type: LOAD_INSTANCES_FAILURE, payload: error.message || error, error: true}));
};

export const LOAD_OBJECTS_REQUEST = 'LOAD_OBJECTS_REQUEST';
export const LOAD_OBJECTS_SUCCESS = 'LOAD_OBJECTS_SUCCESS';
export const LOAD_OBJECTS_FAILURE = 'LOAD_OBJECTS_FAILURE';

export const loadObjects = (instanceId) => (dispatch) => {
  dispatch({type: LOAD_OBJECTS_REQUEST});
  return axios.get(
      `${process.env.REACT_APP_API_URL}/dataDictionary/objects/view/summary?instanceId=${instanceId}&objectType=TABLE,VIEW`,
      {headers: headers()},
  )
      .then((response) => response.data)
      .then((json) => dispatch({type: LOAD_OBJECTS_SUCCESS, payload: json}))
      .catch((error) => dispatch({type: LOAD_OBJECTS_FAILURE, payload: error.message || error, error: true}));
};

export const DISCOVER_VIEW_LINEAGE_REQUEST = 'DISCOVER_VIEW_LINEAGE_REQUEST';
export const DISCOVER_VIEW_LINEAGE_SUCCESS = 'DISCOVER_VIEW_LINEAGE_SUCCESS';
export const DISCOVER_VIEW_LINEAGE_FAILURE = 'DISCOVER_VIEW_LINEAGE_FAILURE';

export const discoverViewLineage = (viewName, instanceId) => (dispatch) => {
  dispatch({type: DISCOVER_VIEW_LINEAGE_REQUEST});
  return axios.get(
      `${process.env.REACT_APP_API_URL}/dataDictionary/views/lineage?viewNames=${viewName}&instanceId=${instanceId}`,
      {headers: headers()},
  )
      .then((response) => response.data)
      .then((json) => dispatch({type: DISCOVER_VIEW_LINEAGE_SUCCESS, payload: json}))
      .catch((error) => dispatch({type: DISCOVER_VIEW_LINEAGE_FAILURE, payload: error.message || error, error: true}));
};
